import { Button, Typography } from '~/components';
import { getTheme, styled } from '~/modules';

const smSpacing = getTheme('spacing.sm');

export const Title = styled(Typography).attrs({
  variant: 'max',
})`
  font-weight: 600;
  margin-bottom: ${smSpacing}px;
`;

export const ButtonComponent = styled(Button)`
  width: 100%;
  margin: auto;
`;
